module.exports = "/build/web/images/partners/vdk.33df823346c810c396117f504d236d2e.png";


//////////////////
// WEBPACK FOOTER
// ./images/partners/vdk.png
// module id = 133
// module chunks = 24